import axios from 'axios';

const SURVEY_API = '/survey';
const USER_SURVEY_API = '/user-survey';

const instance = axios.create({
  withCredentials: true,
  baseURL: `${process.env.VUE_APP_DJ_BASE_URL}api`,
});

const options = {
  headers: {
    'X-CSRFToken': '',
  },
};

/*
* Update the headers of this instance given the app cookie data
* @params { cookies<Object> }
* @return { void }
*/
export const configInstance = (cookies) => {
  if (cookies.get('csrftoken')) {
    /* eslint-disable dot-notation */
    options.headers['X-CSRFToken'] = cookies.get('csrftoken');
  }
};

export const getCampaign = () => instance.get(`${SURVEY_API}/`, options);

export const get = (surveyId) => instance.get(`${SURVEY_API}/${surveyId}/`, options);

export const updateResponse = (userSurveyId, data) => {
  const url = `${SURVEY_API}-response/`;
  const { question, responses } = data;
  const params = {
    user_survey: userSurveyId,
    question,
    responses,
  };
  return instance.post(url, params, options);
};

export const create = (campaignId, status) => {
  const data = {
    campaign: campaignId,
    status,
  };
  return instance.post(`${USER_SURVEY_API}/`, data, options);
};

export const getUserSurvey = (campaignId, surveyId) => {
  const data = {
    campaign: campaignId,
  };
  return instance.get(`${USER_SURVEY_API}/${surveyId}/`, data, options);
};

export const changeStatus = (surveyId, campaignId, status) => {
  const data = {
    campaign: campaignId,
    status,
  };
  return instance.put(`${USER_SURVEY_API}/${surveyId}/`, data, options);
};
